import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import emailInterceptService from "../../services/api/emailInterceptService";

export const fetchEmails = createAsyncThunk(
  'emailIntercept/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await emailInterceptService.getAll();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchStats = createAsyncThunk(
  'emailIntercept/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await emailInterceptService.getStats();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const pollForEmail = createAsyncThunk(
  'emailIntercept/poll',
  async ({ email, appKey }, { rejectWithValue }) => {
    try {
      const response = await emailInterceptService.poll(email, appKey);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const consumeEmail = createAsyncThunk(
  'emailIntercept/consume',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await emailInterceptService.consume(id);
      dispatch(fetchEmails());
      dispatch(fetchStats());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const cleanupExpired = createAsyncThunk(
  'emailIntercept/cleanupExpired',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await emailInterceptService.cleanupExpired();
      dispatch(fetchEmails());
      dispatch(fetchStats());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  emails: [],
  stats: {},
  loading: false,
  error: null,
  polling: false,
};

const emailInterceptSlice = createSlice({
  name: "emailIntercept",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchEmails
      .addCase(fetchEmails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmails.fulfilled, (state, action) => {
        state.emails = action.payload;
        state.loading = false;
      })
      .addCase(fetchEmails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchStats
      .addCase(fetchStats.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.stats = action.payload;
      })
      .addCase(fetchStats.rejected, (state, action) => {
        state.error = action.payload;
      })

      // pollForEmail
      .addCase(pollForEmail.pending, (state) => {
        state.polling = true;
        state.error = null;
      })
      .addCase(pollForEmail.fulfilled, (state, action) => {
        state.polling = false;
      })
      .addCase(pollForEmail.rejected, (state, action) => {
        state.polling = false;
        state.error = action.payload;
      })

      // consumeEmail
      .addCase(consumeEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(consumeEmail.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(consumeEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // cleanupExpired
      .addCase(cleanupExpired.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cleanupExpired.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(cleanupExpired.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = emailInterceptSlice.actions;

export default emailInterceptSlice.reducer;
